import styles from './Banner.module.css';
import React from 'react';
import logoImage from './cpl_logo.png';

export const CPLBanner = function (props) {
    return <div className={`card ${styles['banner-card-wrapper']}`}>
        <div>
            <img src={props.img} alt='header' className={styles['banner-card-img']}/>
            <div className={styles['banner-card-text']}>{props.content}</div>
            <div className={styles['banner-card-logo']}><img style={{width: 191}} src={logoImage} alt="header" /></div>
        </div>
    </div>
}
